import { useAuth } from '@/contexts/auth-context';

/**
 * Global footer strip shown whenever the session is running under an
 * impersonation token. Pinned to the bottom so it stays out of the way of the
 * top nav; mounted at the app shell so it appears across admin AND staff layouts.
 */
export function ImpersonationBanner() {
  const { impersonation, user, stopImpersonation } = useAuth();

  if (!impersonation) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] flex items-center justify-center gap-3 bg-amber-500 px-4 py-1.5 text-xs font-medium text-black shadow-[0_-2px_8px_rgba(0,0,0,0.15)]">
      <span className="truncate">
        Impersonating <strong>{user?.email}</strong>
        {' — '}by {impersonation.impersonatorEmail}
      </span>
      <button
        type="button"
        onClick={() => stopImpersonation()}
        className="shrink-0 rounded bg-black/80 px-2.5 py-0.5 font-semibold text-white hover:bg-black"
      >
        Exit
      </button>
    </div>
  );
}
